import SelectStyled from "@/components/SelectStyled";
import { MenuItem } from "@mui/material";

const LanguageSelector = ({
  name,
  defaultValue,
  value,
  label,
  onChange,
  required = false,
  disabled = false,
}) => {
  const languages = [
    {
      label: "Deutsch",
      value: "de",
    },
    {
      label: "Englisch",
      value: "en",
    },
    {
      label: "Instrumental",
      value: "instrumental",
    },
    {
      label: "Andere",
      value: "others",
    },
  ];

  const handleInputChanged = (event, value) => {
    if (onChange) {
      onChange(event, value);
    }
  };

  return (
    <SelectStyled
      fullWidth
      name={name}
      label={label}
      placeholder="Bitte wählen"
      inputProps={{ "aria-label": "Bitte wählen" }}
      defaultValue={defaultValue}
      value={value}
      onChange={handleInputChanged}
      required={required}
      disabled={disabled}
    >
      <MenuItem value="">Bitte wählen</MenuItem>
      {languages.map((lng, idx) => (
        <MenuItem value={lng} key={lng.value}>
          {lng.label}
        </MenuItem>
      ))}
    </SelectStyled>
  );
};

export default LanguageSelector;
